import { render, staticRenderFns } from "./add-address-modal.vue?vue&type=template&id=92593216&scoped=true"
import script from "./add-address-modal.vue?vue&type=script&lang=js"
export * from "./add-address-modal.vue?vue&type=script&lang=js"
import style0 from "./add-address-modal.vue?vue&type=style&index=0&id=92593216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92593216",
  null
  
)

export default component.exports